<template>
    <el-card class="mini-box-card  box-d-card">
        <template class="mini-card-header" #header>
            <span>Quotations</span>
            <!--  <a :href="'/enquiry/quote/create?enqid='+enquiry.encryptedid">
              <el-button class="white-btn" size="small" >Give New Quotation</el-button>
            </a>-->
            <a :href="'/enquiry/newquote/create?enqid=' + enquiry.encryptedid">
                <el-button class="white-btn" size="small">Give New Quotation (*)</el-button>
            </a>
        </template>
        <el-tabs type="border-card" class="qtn-tabs">
            <el-tab-pane v-for="quotation in enquiry.quotations" :key="quotation.id">
                <template #label>
                    <div class="qnt-list-box">
                        <p class="qtnno">
                            QTN{{ quotation.id }}
                            <el-tag effect="dark" type="success" size="small" v-if="quotation.status == 'Accepted'">
                                Accepted
                            </el-tag>
                            <el-tag effect="dark" type="danger" size="small" v-else-if="quotation.status == 'Rejected'">
                                Rejected
                            </el-tag>
                            <el-tag effect="plain" type="info" size="small" v-else-if="quotation.status == 'Draft'">
                                Draft
                            </el-tag>
                            <el-tag effect="warning" size="small" v-else>
                                {{ quotation.status }}
                            </el-tag>
                        </p>
                        <p class="price">Rs. {{ quotation.quote_price }} <small
                                v-if="quotation.quoteversion == 2">Total</small> <small
                                v-else>{{ quotation.pricetypetext }}</small></p>
                        <p class="detail" v-if="quoteHasDiscount(quotation)">
                            Land package discount Rs. {{ roundMoney(quotation.discount_amount) }}
                            <small v-if="quotation.discount_type === 'percent'">({{ quotation.discount_value }}%)</small>
                        </p>
                        <p class="detail">Updated on <small>{{ quotation.updated_at }}</small></p>
                        <p class="detail" v-if="quotation.time_taken != null">Time Taken
                            <small>{{ convertHMS(quotation.time_taken) }}</small></p>
                    </div>


                </template>

                <div v-if="quotation.quoteversion == 1">
                    <el-row>
                        <el-col>
                            <a :href="'/enquiry/quote/create?enqid=' + enquiry.encryptedid + '&qid=' + quotation.encryptedid">

                                <el-button type="primary" size="small">Edit Quote</el-button>
                            </a>
                            <a :href="'/enquiry/quote/pdf?qid=' + quotation.encryptedid">
                                <el-button type="primary" size="small" class="ml-2">Download Quote</el-button>

                            </a>
                            <el-button :disabled="accepting" :loading="accepting" v-if="quotation.status != 'Accepted'"
                                @click="changequotestatus('Accepted', quotation.id)" type="primary" size="small"
                                class="ml-2">Accept Quote</el-button>
                            <el-button v-if="quotation.status == 'Accepted' && enquiry.status != 'Converted'" type="primary"
                                size="small" class="ml-2" @click="converttobooking(quotation)">
                                Convert to Booking
                            </el-button>
                            <!-- <a target="_blank"
                                :href="'https://support.pickotrip.com/customer/quote?qid=' + quotation.encryptedid">
                                <el-button type="primary" size="small" class="ml-2">View Quote</el-button> -->
                            <!-- </a> -->
                            <el-button type="primary" size="small" class="ml-2" @click="sendquote(quotation.id)">Send
                                Quote</el-button>
                            <el-button type="success" size="small" class="ml-2" @click="sendquotewhatsapp(quotation.id)">Send quote WhatsApp</el-button>
                            <el-button type="warning" size="small" class="ml-2" @click="openSendWhatsappText()">Send WhatsApp Text</el-button>

                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col class="mt-2">
                            <el-descriptions class="margin-top" :column="3" border direction="vertical">

                                <el-descriptions-item>
                                    <template #label>
                                        <div class="cell-item">
                                            Nights/Days
                                        </div>
                                    </template>
                                    {{ quotation.nights }}Nights & {{ quotation.nights + 1 }}Days
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template #label>
                                        <div class="cell-item">
                                            Quotation Price
                                        </div>
                                    </template>
                                    Rs. {{ quotation.quote_price }} <small>{{ quotation.pricetypetext }}</small>
                                </el-descriptions-item>
                                <el-descriptions-item v-if="quoteHasDiscount(quotation)">
                                    <template #label>
                                        <div class="cell-item">
                                            Land package discount
                                        </div>
                                    </template>
                                    Rs. {{ roundMoney(quotation.discount_amount) }}
                                    <small v-if="quotation.discount_type === 'percent'">({{ quotation.discount_value }}%)</small>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template #label>
                                        <div class="cell-item">
                                            Destination
                                        </div>
                                    </template>
                                    <span v-for="destination in quotation.destinations">{{ destination }}</span>
                                </el-descriptions-item>
                            </el-descriptions>
                        </el-col>
                        <el-col class="mt-2" v-if="quotation.hotel_includes == 1">
                            <el-card>
                                <h5>Hotels</h5>
                                <p v-for="hotel in quotation.hotels">
                                    Nights {{ hotel.nights.join(",") }}, {{ hotel.hotelname }}, {{ hotel.city }},
                                    {{ hotel.category }},
                                    {{ hotel.roomtype }}, {{ hotel.comments }}
                                </p>
                            </el-card>
                        </el-col>
                        <el-col class="mt-2" v-if="quotation.flight_includes == 1">
                            <el-card>
                                <h5>Flights</h5>
                                <img v-if="quotation.flightdetails != null && quotation.flightdetails.includes('data:image')"
                                    :src="quotation.flightdetails">
                                <p v-else>
                                    {{ quotation.flightdetails }}
                                </p>
                                <p class="mt-2"> {{ quotation.isrefundableflight == 1 ? 'Refundable' :
                                    quotation.isrefundableflight==0 ? 'Non Refundable' : '' }}</p>

                            </el-card>
                        </el-col>
                    </el-row>
                    <el-card class="mt-2">
                        <el-row>
                            <el-col :span="12">

                                <h5>Inclusions</h5>
                                <ul>
                                    <li v-for="inclusion in quotation.inclusions">{{ inclusion }}</li>
                                </ul>

                            </el-col>
                            <el-col :span="12">

                                <h5>Exclusions</h5>
                                <ul>
                                    <li v-for="exclusion in quotation.exclusions">{{ exclusion }}</li>
                                </ul>


                            </el-col>
                        </el-row>
                    </el-card>

                    <el-collapse class="mt-2" accordion>
                        <el-collapse-item v-for="daytn in quotation.itenaries"
                            :title="'Day ' + daytn.day + ' : ' + daytn.title" :name="daytn.day">
                            <p>
                                <div v-html="daytn.description"></div>
                            </p>
                            <div v-if="daytn.activities && daytn.activities.length" class="mt-2">
                                <div v-for="(act, actIdx) in daytn.activities" :key="actIdx" class="mb-2">
                                    <strong>{{ act.name }}</strong>
                                    <div v-if="activityImageList(act).length" class="mt-1">
                                        <img
                                            v-for="(img, imgIdx) in activityImageList(act)"
                                            :key="imgIdx"
                                            :src="img"
                                            style="height: 80px; width: 120px; object-fit: cover; margin-right: 8px; border-radius: 6px;"
                                        />
                                    </div>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>

                </div>
                <div v-else>
                    <el-row>
                        <el-col>
                            <a
                                :href="'/enquiry/newquote/create?enqid=' + enquiry.encryptedid + '&qid=' + quotation.encryptedid">

                                <el-button type="primary" size="small">{{ quotation.status == 'Draft' ? 'Continue Draft' : 'Edit Quote' }}</el-button>
                            </a>
                            <template v-if="quotation.status != 'Draft'">
                            <a :href="'/enquiry/newquote/pdf?qid=' + quotation.encryptedid">
                                <el-button type="primary" size="small" class="ml-2">Download Quote</el-button>

                            </a>
                            <el-button :disabled="accepting" :loading="accepting" v-if="quotation.status != 'Accepted'"
                                @click="changequotestatus('Accepted', quotation.id)" type="primary" size="small"
                                class="ml-2">Accept Quote</el-button>
                            <el-button v-if="quotation.status == 'Accepted' && enquiry.status != 'Converted'" type="primary"
                                size="small" class="ml-2" @click="converttobooking(quotation)">
                                Convert to Booking
                            </el-button>


                            <!-- <a target="_blank" :href="'https://www.pickotrip.com/quotations/' + quotation.encryptedid">
                                <el-button type="primary" size="small" class="ml-2">View Quote</el-button>
                            </a> -->

                            <el-button type="primary" size="small" class="ml-2" @click="sendquote(quotation.id)">Send
                                Quote</el-button>
                            <el-button type="success" size="small" class="ml-2" @click="sendquotewhatsapp(quotation.id)">Send quote WhatsApp</el-button>
                            <el-button type="warning" size="small" class="ml-2" @click="openSendWhatsappText()">Send WhatsApp Text</el-button>
                            </template>


                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col class="mt-2">
                            <el-descriptions class="margin-top" :column="3" border direction="vertical">

                                <el-descriptions-item>
                                    <template #label>
                                        <div class="cell-item">
                                            Nights/Days
                                        </div>
                                    </template>
                                    {{ quotation.nights }}Nights & {{ quotation.nights + 1 }}Days
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template #label>
                                        <div class="cell-item">
                                            Quotation Price
                                        </div>
                                    </template>
                                    Rs. {{ quotation.quote_price }} <small>Total</small>
                                </el-descriptions-item>
                                <el-descriptions-item v-if="quoteHasDiscount(quotation)">
                                    <template #label>
                                        <div class="cell-item">
                                            Land package discount
                                        </div>
                                    </template>
                                    Rs. {{ roundMoney(quotation.discount_amount) }}
                                    <small v-if="quotation.discount_type === 'percent'">({{ quotation.discount_value }}%)</small>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template #label>
                                        <div class="cell-item">
                                            Destination
                                        </div>
                                    </template>
                                    <span v-for="destination in quotation.destinations">{{ destination }}</span>
                                </el-descriptions-item>
                            </el-descriptions>
                        </el-col>
                        <el-col class="mt-2" v-if="quotation.hotel_includes == 1">
                            <el-card>
                                <h5>Hotels</h5>
                                <div v-for="hotel in quotation.hotels" class="mb-3">
                                    <div v-if="hotelImageList(hotel).length" class="mb-2">
                                        <img
                                            v-for="(img, imgIdx) in hotelImageList(hotel)"
                                            :key="imgIdx"
                                            :src="img"
                                            style="height: 90px; width: 140px; object-fit: cover; margin-right: 8px; border-radius: 6px;"
                                        />
                                    </div>
                                    <p>
                                    CheckIn- {{ hotel.data.checkIn }}, CheckOut- {{ hotel.data.checkOut }}, {{
                                    hotel.data.name}},
                                    {{ hotel.data.city }}, {{ hotel.data.rating }} Star, {{ hotel.data.type }}
                                    </p>
                                <h6>Rooms</h6>
                                <p v-for="room in hotel.data.rooms">
                                    {{ room.type }}, for {{ room.adt }} A <span v-if="room.chd > 0"> - {{ room.chd }}
                                        C</span> ,
                                    {{ Array.isArray(room.mb) ? room.mb.join(', ') : room.mb }}
                                </p>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col class="mt-2" v-if="quotation.flight_includes == 1">
                            <el-card>
                                <h5>Flights</h5>
                                <div v-for="flight in quotation.flights">
                                    <!-- <div v-if="flight.source=='mannual'">
                                        <img v-if="flight.data && flight.data.includes('data:image')" :src="'/' + flight.data"  style="width:100%">
                                        <p v-else>
                                            {{flight.data}}
                                        </p>
                                        <p class="mt-2"> {{ flight.refundable ? 'Refundable' : !flight.refundable ? 'Non Refundable' : '' }}</p>

                                    </div> -->
                                    <div v-if="flight.source == 'mannual'">

                                        <!-- Show Image Only If It's Stored File Path -->
                                        <img v-if="flight.data && !flight.data.includes('data:image')"
                                            :src="'/' + flight.data" style="width:100%">

                                        <!-- Otherwise Show As Text -->
                                        <p v-else>
                                            {{ flight.data }}
                                        </p>

                                        <p class="mt-2">
                                            {{ flight.refundable ? 'Refundable' : !flight.refundable ? 'Non Refundable'
                                            : '' }}
                                        </p>

                                    </div>


                                    <div v-else-if="flight.source == 'api' && flight.type == 'single'">

                                        <flight-combo-details-card :flight="flight.data"></flight-combo-details-card>
                                        <p class="mt-2"> {{ flight.refundable ? 'Refundable' : !flight.refundable ? 'Non Refundable' : '' }}</p>

                                    </div>
                                    <div v-else-if="flight.source == 'api' && flight.type == 'combo'">


                                        <flight-combo-details-card
                                            :flight="flight.data.departure"></flight-combo-details-card>
                                        <br>
                                        <flight-combo-details-card
                                            :flight="flight.data.return"></flight-combo-details-card>
                                        <p class="mt-2"> {{ flight.refundable ? 'Refundable' : !flight.refundable ? 'Non Refundable' : '' }}</p>

                                    </div>

                                </div>
                            </el-card>
                        </el-col>

                    </el-row>
                    <el-card
                        v-if="(quotation.inclusions && quotation.inclusions.length > 0) || (quotation.exclusions && quotation.exclusions.length > 0)"
                        class="mt-2">
                        <el-row>
                            <el-col :span="12">

                                <h5>Inclusions</h5>
                                <ul>
                                    <li v-for="inclusion in quotation.inclusions">{{ inclusion }}</li>
                                </ul>

                            </el-col>
                            <el-col :span="12">

                                <h5>Exclusions</h5>
                                <ul>
                                    <li v-for="exclusion in quotation.exclusions">{{ exclusion }}</li>
                                </ul>


                            </el-col>
                        </el-row>
                    </el-card>
                    <el-collapse class="mt-2" accordion>
                        <el-collapse-item v-for="daytn in quotation.itenaries"
                            :title="'Day ' + daytn.day + ' : ' + daytn.title" :name="daytn.day">
                            <p>
                                <div v-html="daytn.description"></div>
                            </p>
                            <div v-if="daytn.activities && daytn.activities.length" class="mt-2">
                                <div v-for="(act, actIdx) in daytn.activities" :key="actIdx" class="mb-2">
                                    <strong>{{ act.name }}</strong>
                                    <div v-if="activityImageList(act).length" class="mt-1">
                                        <img
                                            v-for="(img, imgIdx) in activityImageList(act)"
                                            :key="imgIdx"
                                            :src="img"
                                            style="height: 80px; width: 120px; object-fit: cover; margin-right: 8px; border-radius: 6px;"
                                        />
                                    </div>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>

                </div>
            </el-tab-pane>

        </el-tabs>

    </el-card>
    <el-dialog v-model="sendquotewhatsappmodel" title="Send Quote WhatsApp" width="500">
        <el-form ref="sendquoteWhatsappFormRef" :model="sendquotewhatsappform" status-icon :rules="sendquotewhatsapprules" label-width="auto"
            class="demo-ruleForm" label-position="top">
            <el-form-item label="WhatsApp number" prop="mobile">
                <el-input v-model="sendquotewhatsappform.mobile" placeholder="WhatsApp number" />
            </el-form-item>
            <el-form-item label="Caption" prop="caption">
                <el-input
                    v-model="sendquotewhatsappform.caption"
                    type="textarea"
                    :rows="3"
                    placeholder="WhatsApp caption text"
                />
                <!-- <small style="color:#909399">Prefilled with the default caption. Edit if you want to change it.</small> -->
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button :disabled="sendingquotewhatsapp" :loading="sendingquotewhatsapp" type="success" @click="submitSendQuoteWhatsappForm">
                    Send
                </el-button>
            </div>
        </template>
    </el-dialog>
    <el-dialog v-model="sendWhatsappTextModel" title="Send WhatsApp Text" width="500">
        <el-form ref="sendWhatsappTextFormRef" :model="sendWhatsappTextForm" status-icon :rules="sendWhatsappTextRules" label-width="auto"
            class="demo-ruleForm" label-position="top">
            <el-form-item label="WhatsApp number" prop="mobile">
                <el-input v-model="sendWhatsappTextForm.mobile" placeholder="WhatsApp number" />
            </el-form-item>
            <el-form-item label="Message" prop="message">
                <el-input
                    v-model="sendWhatsappTextForm.message"
                    type="textarea"
                    :rows="12"
                    placeholder="Enter WhatsApp text"
                />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button :disabled="sendingWhatsappText" :loading="sendingWhatsappText" type="warning" @click="submitSendWhatsappTextForm">
                    Send
                </el-button>
            </div>
        </template>
    </el-dialog>
    <el-dialog v-model="sendquotemodel" title="Send Quote" width="500">
        <el-form ref="sendquoteFormRef" :model="sendquoteform" status-icon :rules="sendquoterules" label-width="auto"
            class="demo-ruleForm" label-position="top">
            <el-form-item label="Email" prop="emailid">
                <el-input v-model="sendquoteform.emailid" placeholder="Email" />

            </el-form-item>

        </el-form>
        <template #footer>
            <div class="dialog-footer">

                <el-button :disabled="sendingquote" :loading="sendingquote" type="primary" @click="submitSendQuoteForm">
                    Send
                </el-button>
            </div>
        </template>
    </el-dialog>


    <el-drawer v-model="convertemodel" direction="rtl" size="560px">
        <template #header>
            <h4>Convert to Booking</h4>
        </template>
        <template #default>
            <el-form ref="convertFormRef" :model="convertform" status-icon :rules="convertrules" label-width="auto"
                class="demo-ruleForm convert-cascade-form" label-position="top">

                <el-form-item label="Customer total" prop="quoteprice">
                    <el-input type="number" v-model="convertform.quoteprice" readonly placeholder="Quote Price" />
                </el-form-item>

                <div v-if="quoteHasDiscount(currentquotation)" class="mb-3" style="background:#f4f4f5;padding:12px;border-radius:4px;">
                    <p style="margin:0 0 4px;font-weight:600;">{{ currentquotation.discount_type === 'amount' ? 'Discount off the customer total' : 'Land package discount (before land GST and TCS)' }}</p>
                    <p style="margin:0;">
                        Rs. {{ roundMoney(currentquotation.discount_amount) }}
                        <small v-if="currentquotation.discount_type === 'percent'">({{ currentquotation.discount_value }}%)</small>
                    </p>
                    <p style="margin:4px 0 0;">Customer total: Rs. {{ roundMoney(currentquotation.quote_price) }}</p>
                    <p style="margin:4px 0 0;color:#909399;font-size:12px;">Booking discount below is separate. It applies to the land package only.</p>
                </div>

                <el-form-item label="Discount Type">
                    <el-select style="width:100%" v-model="convertform.discount_type" @change="calculateconvertprofit">
                        <el-option label="Percent (%)" value="percent"></el-option>
                        <el-option label="Amount (₹)" value="amount"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="convertform.discount_type === 'percent' ? 'Discount (%) of land before GST' : 'Discount off the customer total (₹)'" prop="discount_value">
                    <el-input type="number" min="0" step="0.01" v-model="convertform.discount_value"
                        @input="calculateconvertprofit" @change="calculateconvertprofit"
                        :placeholder="convertform.discount_type === 'percent' ? 'Percent of land before GST' : 'Rupees off the customer total'" />
                </el-form-item>
                <el-form-item :label="convertform.discount_type === 'amount' ? 'Discount off customer total' : 'Land discount'">
                    <el-input type="number" v-model="convertform.discount_amount" readonly />
                </el-form-item>
                <el-form-item label="Removed before GST">
                    <el-input type="number" v-model="convertform.pre_tax_discount" readonly />
                </el-form-item>
                <el-form-item label="Discount Reason" prop="discount_reason"
                    :rules="discountReasonRules">
                    <el-input type="textarea" v-model="convertform.discount_reason"
                        placeholder="Required when discount is greater than 0" />
                </el-form-item>

                <p class="convert-section-title">Editable Base Costs</p>

                <el-form-item label="Hotel Cost" prop="hotelprice" v-if="convertShow.hotel">
                    <el-input type="number" v-model="convertform.hotelprice"
                        @input="calculateconvertprofit" @change="calculateconvertprofit"
                        placeholder="Hotel Cost" />
                </el-form-item>
                <el-form-item label="Transportation Cost" v-if="convertShow.transportation">
                    <el-input type="number" v-model="convertTransportationInput"
                        @input="calculateconvertprofit" @change="calculateconvertprofit"
                        placeholder="Transportation Cost" />
                </el-form-item>
                <el-form-item label="Other Addons" v-if="convertShow.other_addons">
                    <el-input type="number" v-model="convertOtherAddonsInput"
                        @input="calculateconvertprofit" @change="calculateconvertprofit"
                        placeholder="Other Addons" />
                </el-form-item>
                <el-form-item label="Activities & Transfers" prop="landprice" v-if="convertShow.land">
                    <el-input type="number" v-model="convertform.landprice"
                        @input="calculateconvertprofit" @change="calculateconvertprofit"
                        placeholder="Activities & Transfers" />
                </el-form-item>
                <el-form-item label="Cruise Cost" prop="cruiseprice" v-if="convertShow.cruise">
                    <el-input type="number" v-model="convertform.cruiseprice"
                        @input="calculateconvertprofit" @change="calculateconvertprofit"
                        placeholder="Cruise Cost" />
                </el-form-item>
                <el-form-item label="Visa Cost" prop="visaprice" v-if="convertShow.visa">
                    <el-input type="number" v-model="convertform.visaprice"
                        @input="calculateconvertprofit" @change="calculateconvertprofit"
                        placeholder="Visa Cost" />
                </el-form-item>
                <el-form-item label="Travel Insurance Cost" prop="travelinsuranceprice" v-if="convertShow.insurance">
                    <el-input type="number" v-model="convertform.travelinsuranceprice"
                        @input="calculateconvertprofit" @change="calculateconvertprofit"
                        placeholder="Travel Insurance Cost" />
                </el-form-item>
                <el-form-item label="Helicopter Cost" v-if="convertShow.helicopter">
                    <el-input type="number" v-model="convertHelicopterInput"
                        @input="calculateconvertprofit" @change="calculateconvertprofit"
                        placeholder="Helicopter Cost" />
                </el-form-item>
                <el-form-item label="Flight Cost" prop="flightprice" v-if="convertShow.flight">
                    <el-input type="number" v-model="convertform.flightprice"
                        @input="calculateconvertprofit" @change="calculateconvertprofit"
                        placeholder="Flight Cost" />
                </el-form-item>

                <!-- Land Package Cascade -->
                <div v-if="convertShow.land_cascade" class="land-cascade mt-3">
                    <p class="land-cascade-title"><strong>Land Package Cascade</strong></p>
                    <table class="land-cascade-table">
                        <tbody>
                            <tr v-if="convertLandCascade.hotel_cost > 0 || convertShow.hotel">
                                <td>Hotel (Stays)</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.hotel_cost) }}</td>
                            </tr>
                            <tr v-if="convertLandCascade.hotel_cost > 0 || convertShow.hotel">
                                <td>Hotel Service Cost ({{ convertRates.hotel_service_charge }}%)</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.hotel_profit) }}</td>
                            </tr>
                            <tr v-if="convertLandCascade.hotel_cost > 0 || convertShow.hotel" class="sub">
                                <td>Sub Hotel Cost</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.hotel_subtotal) }}</td>
                            </tr>
                            <template v-for="line in (convertLandCascade.markup_addons || [])" :key="'cv-markup-'+line.code">
                                <tr v-if="line.cost > 0">
                                    <td>{{ line.name }}</td>
                                    <td class="amt">{{ formatMoney(line.cost) }}</td>
                                </tr>
                                <tr v-if="line.cost > 0">
                                    <td>{{ line.name }} Service Cost ({{ line.percent }}%)</td>
                                    <td class="amt">{{ formatMoney(line.profit) }}</td>
                                </tr>
                                <tr v-if="line.cost > 0" class="sub">
                                    <td>Sub {{ line.name }} Total</td>
                                    <td class="amt">{{ formatMoney(line.subtotal) }}</td>
                                </tr>
                            </template>
                            <tr v-if="convertLandCascade.other_addons_cost > 0">
                                <td>Other Addons</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.other_addons_cost) }}</td>
                            </tr>
                            <tr v-if="convertLandCascade.activities_cost > 0 || convertShow.land">
                                <td>Activities &amp; Transfers</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.activities_cost) }}</td>
                            </tr>
                            <tr v-if="convertLandCascade.cruise_cost > 0 || convertShow.cruise">
                                <td>Cruise</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.cruise_cost) }}</td>
                            </tr>
                            <tr v-if="convertLandCascade.visa_cost > 0 || convertShow.visa">
                                <td>Visa</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.visa_cost) }}</td>
                            </tr>
                            <tr v-if="convertLandCascade.insurance_cost > 0 || convertShow.insurance">
                                <td>Insurance</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.insurance_cost) }}</td>
                            </tr>
                            <tr class="sub">
                                <td>Land Subtotal</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.land_subtotal) }}</td>
                            </tr>
                            <tr>
                                <td>Backup ({{ convertRates.backup_cost }}%)</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.backup_cost) }}</td>
                            </tr>
                            <tr class="sub">
                                <td>After Backup</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.after_backup) }}</td>
                            </tr>
                            <tr>
                                <td>Overall Service Cost ({{ convertRates.overall_service_charge }}%)</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.service_cost) }}</td>
                            </tr>
                            <tr>
                                <td>Profit ({{ convertRates.land_profit }}%)</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.land_profit) }}</td>
                            </tr>
                            <tr class="sub">
                                <td>Land Before GST</td>
                                <td class="amt">{{ formatMoney(convertLandCascade.land_before_gst) }}</td>
                            </tr>
                            <tr v-if="convertCharged && Number(convertCharged.pre_tax_discount) > 0">
                                <td>Removed before GST</td>
                                <td class="amt">{{ formatMoney(convertCharged.pre_tax_discount) }}</td>
                            </tr>
                            <tr>
                                <td>Land GST ({{ convertRates.land_gst }}%)</td>
                                <td class="amt">{{ formatMoney(convertCharged ? convertCharged.land_gst : convertLandCascade.land_gst) }}</td>
                            </tr>
                            <tr v-if="convertTcsIncluded">
                                <td>TCS ({{ convertRates.tcs }}%)</td>
                                <td class="amt">{{ formatMoney(convertCharged ? convertCharged.tcs : convertLandCascade.tcs) }}</td>
                            </tr>
                            <tr class="grand-row">
                                <td>Total Package Cost</td>
                                <td class="amt">{{ formatMoney(convertCharged ? convertCharged.land_total : convertLandCascade.package_total) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Separate cascades (e.g. Helicopter) -->
                <div
                    v-for="line in (convertSeparateCascades || []).filter(l => l.cost > 0)"
                    :key="'cv-sep-'+line.code"
                    class="land-cascade mt-3"
                >
                    <p class="land-cascade-title"><strong>{{ line.name }}</strong></p>
                    <table class="land-cascade-table">
                        <tbody>
                            <tr>
                                <td>{{ line.name }} Cost</td>
                                <td class="amt">{{ formatMoney(line.cost) }}</td>
                            </tr>
                            <tr>
                                <td>{{ line.name }} Service Cost ({{ line.service_cost_percent }}%)</td>
                                <td class="amt">{{ formatMoney(line.profit) }}</td>
                            </tr>
                            <tr class="sub">
                                <td>Subtotal (Cost + Service Cost)</td>
                                <td class="amt">{{ formatMoney(line.before_gst) }}</td>
                            </tr>
                            <tr>
                                <td>GST ({{ line.gst_percent }}%)</td>
                                <td class="amt">{{ formatMoney(line.gst) }}</td>
                            </tr>
                            <tr class="grand-row">
                                <td>{{ line.name }} Total</td>
                                <td class="amt">{{ formatMoney(line.total) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Flight cascade -->
                <div v-if="convertShow.flight" class="land-cascade mt-3">
                    <p class="land-cascade-title"><strong>Flight</strong></p>
                    <table class="land-cascade-table">
                        <tbody>
                            <tr>
                                <td>Flight Cost</td>
                                <td class="amt">{{ formatMoney(convertform.flightprice) }}</td>
                            </tr>
                            <tr>
                                <td>Flight Service Cost ({{ convertRates.flight_service_charge }}%)</td>
                                <td class="amt">{{ formatMoney(convertFlight.service) }}</td>
                            </tr>
                            <tr class="sub">
                                <td>Subtotal (Cost + Service Cost)</td>
                                <td class="amt">{{ formatMoney(convertFlight.subtotal) }}</td>
                            </tr>
                            <tr>
                                <td>Flight GST ({{ convertRates.flight_gst }}% on service cost)</td>
                                <td class="amt">{{ formatMoney(convertFlight.gst) }}</td>
                            </tr>
                            <tr class="grand-row">
                                <td>Flight Total</td>
                                <td class="amt">{{ formatMoney(convertFlight.total) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Pricing Summary -->
                <div class="land-cascade-summary mt-3" v-if="convertShow.land_cascade || convertShow.flight || convertShow.helicopter">
                    <p class="convert-section-title">Pricing Summary</p>
                    <p v-if="convertShow.land_cascade"><strong>Total Package Cost — {{ formatMoney(convertLandCascade.package_total) }}</strong></p>
                    <p v-for="line in (convertSeparateCascades || []).filter(l => l.cost > 0)" :key="'cv-sum-sep-'+line.code">
                        <strong>{{ line.name }} Total — {{ formatMoney(line.total) }}</strong>
                    </p>
                    <p v-if="convertShow.flight"><strong>Flight Total — {{ formatMoney(convertFlight.total) }}</strong></p>
                    <p><strong>Customer total — {{ formatMoney(convertform.quoteprice) }}</strong></p>
                </div>

                <el-form-item :label="'Land GST (' + convertRates.land_gst + '%)'" prop="land_gst" v-if="convertShow.land_cascade">
                    <el-input type="number" v-model="convertform.land_gst" readonly />
                </el-form-item>
                <el-form-item :label="'Flight GST (' + convertRates.flight_gst + '%)'" prop="flight_gst" v-if="convertShow.flight">
                    <el-input type="number" v-model="convertform.flight_gst" readonly />
                </el-form-item>
                <el-form-item
                    v-for="line in (convertSeparateCascades || []).filter(l => l.cost > 0)"
                    :key="'cv-gst-'+line.code"
                    :label="line.name + ' GST (' + line.gst_percent + '%)'"
                >
                    <el-input type="number" :model-value="roundMoney(line.gst)" readonly />
                </el-form-item>
                <el-form-item label="Total GST" prop="gst">
                    <el-input type="number" v-model="convertform.gst" placeholder="Total GST" readonly />
                </el-form-item>
                <el-form-item label="TCS" prop="tdsprice" v-if="convertTcsIncluded">
                    <el-input type="number" v-model="convertform.tdsprice" readonly />
                </el-form-item>
                <el-form-item label="Profit" prop="profit">
                    <el-input type="number" v-model="convertform.profit" placeholder="Profit" readonly />
                </el-form-item>

            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="convertemodel = false">Cancel</el-button>
                <el-button type="primary" @click="submitConvertForm()" :loading="converting"
                    :disabled="converting">Convert to Booking</el-button>
            </div>
        </template>
    </el-drawer>
</template>

<script>
import {
    ElCollapse, ElCollapseItem, ElTabPane, ElTabs, ElCard, ElTag, ElRow, ElCol, ElButton, ElDialog, ElForm, ElFormItem, ElInput, ElDrawer, ElDescriptions, ElDescriptionsItem, ElSelect, ElOption
} from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
import $ from "jquery";
import FlightComboDetailsCard from "../../Quotation/Flight/Components/FlightComboDetailsCard.vue";
import { roundMoney, formatMoney } from "../../../utils/money";
import {
    applyDiscountBeforeTax,
    calculateLandCascade,
    calculateSeparateCascades,
    calculateHelicopterCascade,
    emptyLandCascade,
    sumItineraryActivitiesAndTransfers,
    DEFAULT_PRICING_RATES,
    DEFAULT_ADDON_TYPES,
} from "../../../utils/landPricing";

export default {
    name: "EnquiryQuotataions",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { FlightComboDetailsCard, ElCollapse, ElCollapseItem, ElTabPane, ElTabs, ElCard, ElTag, ElRow, ElCol, ElButton, Edit, ElDialog, ElForm, ElFormItem, ElInput, ElDescriptions, ElDrawer, ElDescriptionsItem, ElSelect, ElOption },
    data() {
        return {
            accepting: false,
            converting: false,
            sendingquote: false,
            sendingquotewhatsapp: false,
            sendingWhatsappText: false,
            sendquotemodel: false,
            sendquotewhatsappmodel: false,
            sendWhatsappTextModel: false,
            convertemodel: false,
            currentquotation: null,
            convertRates: { ...DEFAULT_PRICING_RATES },
            convertAddonTypes: [...DEFAULT_ADDON_TYPES],
            convertTransportationInput: 0,
            convertOtherAddonsInput: 0,
            convertHelicopterInput: 0,
            convertExtraMarkupAddons: [],
            convertTcsIncluded: false,
            convertLandCascade: emptyLandCascade(),
            convertSeparateCascades: [],
            convertFlight: { service: 0, gst: 0, subtotal: 0, total: 0 },
            convertCharged: null,
            convertShow: {
                hotel: false,
                flight: false,
                visa: false,
                land: false,
                cruise: false,
                insurance: false,
                transportation: false,
                other_addons: false,
                helicopter: false,
                land_cascade: false,
            },
            sendquoteform: {
                qid: '',
                emailid: ''
            },
            sendquotewhatsappform: {
                qid: '',
                mobile: '',
                caption: '',
            },
            sendquotewhatsapprules: {
                mobile: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
                caption: [
                    {
                        required: true,
                        message: 'Enter caption text',
                        trigger: ['blur', 'change'],
                    }
                ],
            },
            sendWhatsappTextForm: {
                enquiry_id: null,
                mobile: '',
                message: '',
            },
            sendWhatsappTextRules: {
                mobile: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
                message: [
                    {
                        required: true,
                        message: 'Enter message text',
                        trigger: ['blur', 'change'],
                    }
                ],
            },
            sendquoterules: {
                emailid: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    },
                    {
                        type: 'email',
                        message: 'Please input correct email address',
                        trigger: ['blur', 'change'],
                    }
                ]
            },
            convertform: {
                eid: '',
                qid: '',
                quoteprice: '',
                hotelprice: 0,
                visaprice: 0,
                landprice: 0,
                flightprice: 0,
                cruiseprice: 0,
                travelinsuranceprice: 0,
                tdsprice: 0,
                land_gst: 0,
                flight_gst: 0,
                profit: '',
                gst: '',
                land_quote_price: 0,
                flight_quote_price: 0,
                land_profit: 0,
                flight_profit: 0,
                hotel_profit: 0,
                transportation_cost: 0,
                transportation_profit: 0,
                backup_cost: 0,
                service_cost: 0,
                land_before_gst: 0,
                pre_tax_discount: 0,
                land_after_discount: 0,
                land_gst_percent: 5,
                tcs_percent: 2,
                tcs_included: 0,
                taxes_absorbed: 0,
                helicopter_cost: 0,
                helicopter_profit: 0,
                helicopter_gst: 0,
                helicopter_total: 0,
                discount_type: 'percent',
                discount_value: 0,
                discount_amount: 0,
                discount_reason: '',
            },
            convertrules: {
                quoteprice: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
                hotelprice: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
                visaprice: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
                landprice: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
                flightprice: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
                cruiseprice: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
                travelinsuranceprice: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
                tdsprice: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
                profit: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
                gst: [
                    {
                        required: true,
                        message: 'Required',
                        trigger: ['blur', 'change'],
                    }
                ],
            },

        }
    },
    computed: {
        discountReasonRules() {
            return [
                {
                    validator: (rule, value, callback) => {
                        if (parseFloat(this.convertform.discount_amount || 0) > 0) {
                            if (!value || !String(value).trim()) {
                                callback(new Error('Discount reason is required when discount > 0'));
                                return;
                            }
                        }
                        callback();
                    },
                    trigger: ['blur', 'change'],
                },
            ];
        },
    },
    created() {

    },
    methods: {
        formatMoney,
        roundMoney,
        quoteHasDiscount(quotation) {
            return parseFloat(quotation && quotation.discount_amount || 0) > 0;
        },
        hotelImageList(hotel) {
            const data = hotel && hotel.data ? hotel.data : {};
            let images = [];
            if (Array.isArray(data.images) && data.images.length) {
                images = data.images;
            } else if (data.image) {
                images = [data.image];
            }
            return images.filter((url) => typeof url === 'string' && url.trim() !== '').slice(0, 2);
        },
        activityImageList(activity) {
            if (!activity) {
                return [];
            }
            let images = [];
            if (Array.isArray(activity.images) && activity.images.length) {
                images = activity.images;
            } else if (activity.image && String(activity.image).indexOf('noimage') === -1) {
                images = [activity.image];
            }
            return images.filter((url) => typeof url === 'string' && url.trim() !== '').slice(0, 2);
        },
        convertHMS(value) {
            const sec = parseInt(value, 10); // convert value to number if it's string
            let hours = Math.floor(sec / 3600); // get hours
            let minutes = Math.floor((sec - (hours * 3600)) / 60); // get minutes
            let seconds = sec - (hours * 3600) - (minutes * 60); //  get seconds
            // add 0 if value < 10; Example: 2 => 02
            if (hours < 10) { hours = "0" + hours; }
            if (minutes < 10) { minutes = "0" + minutes; }
            if (seconds < 10) { seconds = "0" + seconds; }
            if (hours > 0) {
                return hours + ':' + minutes + ':' + seconds;
            }
            else if (minutes > 0) {
                return minutes + ':' + seconds;
            }
            else {
                return seconds;
            }

        },
        changequotestatus(status, id) {
            let currentObj = this;
            currentObj.accepting = true;
            axios.post('/enquiry/quote/setsttaus', { status: status, qid: id, eid: this.enquiry.id }).then(function (response) {
                toastr.success('Quote Status Succesfully Changed.');
                currentObj.accepting = false;
                currentObj.$emit("saved");

            })
                .catch(function (error) {
                    currentObj.accepting = false;
                    toastr.error('Something Wrong try again.');
                });
        },
        sendquote(qid) {
            this.sendquotemodel = true;
            this.sendquoteform.qid = qid;
            this.sendquoteform.emailid = this.enquiry.email_id;
        },
        sendquotewhatsapp(qid) {
            this.sendquotewhatsappmodel = true;
            this.sendquotewhatsappform.qid = qid;
            this.sendquotewhatsappform.mobile = this.enquiry.mobile || '';
            const quotation = (this.enquiry.quotations || []).find((item) => item.id === qid) || null;
            this.sendquotewhatsappform.caption = this.buildDefaultQuoteCaption(quotation);
        },
        buildDefaultQuoteCaption(quotation) {
            const destinations = (quotation && Array.isArray(quotation.destinations))
                ? quotation.destinations.filter(Boolean)
                : [];
            if (destinations.length > 0) {
                return 'Package quotation for ' + destinations.join(', ');
            }
            return 'Package quotation';
        },
        openSendWhatsappText() {
            this.sendWhatsappTextModel = true;
            this.sendWhatsappTextForm.enquiry_id = this.enquiry.id;
            this.sendWhatsappTextForm.mobile = this.enquiry.mobile || '';
            this.sendWhatsappTextForm.message = this.buildDefaultWhatsappText();
        },
        buildDefaultWhatsappText() {
            const name = (this.enquiry && this.enquiry.name ? String(this.enquiry.name).trim() : '') || 'Traveller';
            return (
                'Dear ' + name + ',\n' +
                '\n' +
                'Warm greetings from Badachardham! 🌸\n' +
                '\n' +
                'We tried reaching you by phone to confirm the details of your package, but unfortunately, we were unable to reach you.\n' +
                '\n' +
                'We’d be happy to assist you with any questions, changes, or additional information you may need. Please feel free to call us back on this number. We look forward to assisting you and making your holiday experience truly memorable! 😊\n' +
                '\n' +
                'Warm regards,\n' +
                'Team Badachardham\n' +
                'https://badachardham.com'
            );
        },
        submitSendWhatsappTextForm() {
            const formEl = this.$refs.sendWhatsappTextFormRef;
            if (!formEl) return;
            formEl.validate((valid) => {
                if (valid) {
                    this.submitSendWhatsappText();
                }
            });
        },
        submitSendWhatsappText() {
            let currentObj = this;
            currentObj.sendingWhatsappText = true;
            axios.post('/enquiry/sendwhatsapptext', this.sendWhatsappTextForm).then(function (response) {
                toastr.success((response.data && response.data.message) ? response.data.message : 'WhatsApp text sent successfully.');
                currentObj.sendingWhatsappText = false;
                currentObj.sendWhatsappTextModel = false;
                currentObj.$emit('saved');
            }).catch(function (error) {
                currentObj.sendingWhatsappText = false;
                const message = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : 'Something went wrong. Try again.';
                toastr.error(message);
            });
        },
        submitSendQuoteWhatsappForm() {
            const formEl = this.$refs.sendquoteWhatsappFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.submitsendquotewhatsapp()
                } else {
                    return false
                }
            })
        },
        submitsendquotewhatsapp() {
            let currentObj = this;
            currentObj.sendingquotewhatsapp = true;
            axios.post('/enquiry/quote/sendwhatsapp', this.sendquotewhatsappform).then(function (response) {
                toastr.success((response.data && response.data.message) ? response.data.message : 'Quotation successfully sent on WhatsApp.');
                currentObj.sendingquotewhatsapp = false;
                currentObj.$emit("saved");
                currentObj.sendquotewhatsappmodel = false;
            })
                .catch(function (error) {
                    currentObj.sendingquotewhatsapp = false;
                    const message = (error.response && error.response.data && error.response.data.message)
                        ? error.response.data.message
                        : 'Something went wrong. Try again.';
                    toastr.error(message);
                });
        },
        submitSendQuoteForm() {
            const formEl = this.$refs.sendquoteFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.submitsendquote()
                } else {
                    return false
                }
            })
        },
        submitsendquote() {
            let currentObj = this;
            currentObj.sendingquote = true;
            axios.post('/enquiry/quote/sendmail', this.sendquoteform).then(function (response) {
                toastr.success('Quotation Sucessfully Send.');
                currentObj.sendingquote = false;
                currentObj.$emit("saved");
                currentObj.sendquotemodel = false;
            })
                .catch(function (error) {
                    currentObj.sendingquote = false;
                });
        },
        converttobooking(cquotation) {
            this.convertform.eid = this.enquiry.id;
            this.convertform.qid = cquotation.id;
            this.currentquotation = cquotation;
            this.convertform.discount_reason = '';
            const savedCalc = (cquotation.pricingdetails && cquotation.pricingdetails.calculation) || {};
            const savedType = cquotation.discount_type || savedCalc.discount_type || 'percent';
            const savedValue = parseFloat(
                (cquotation.discount_value !== undefined && cquotation.discount_value !== null && cquotation.discount_value !== '')
                    ? cquotation.discount_value
                    : (savedCalc.discount_value || 0)
            ) || 0;
            if (savedValue > 0) {
                this.convertform.discount_type = savedType === 'amount' ? 'amount' : 'percent';
                this.convertform.discount_value = savedValue;
            } else {
                this.convertform.discount_type = 'percent';
                this.convertform.discount_value = 0;
            }
            this.convertform.discount_amount = 0;

            const p = cquotation.pricingdetails || null;
            const lc = (p && p.landcascade) || {};
            const hc = (p && p.helicoptercascade) || {};
            const rates = {
                ...DEFAULT_PRICING_RATES,
                ...((p && p.rates_used) || {}),
            };
            if (p && p.tax_application) {
                rates.taxes_absorbed = p.tax_application === 'absorbed' ? 1 : 0;
            }
            const addonTypes = (p && Array.isArray(p.addon_types_used) && p.addon_types_used.length)
                ? p.addon_types_used
                : DEFAULT_ADDON_TYPES;

            this.convertRates = rates;
            this.convertAddonTypes = addonTypes;

            const sumHotelLineTotals = (hotels) => {
                if (!Array.isArray(hotels)) return 0;
                return hotels.reduce((sum, h) => {
                    const line = parseFloat(h?.pricing?.total ?? h?.total ?? 0);
                    return sum + (Number.isFinite(line) ? line : 0);
                }, 0);
            };
            const pickPositiveAmount = (...vals) => {
                for (const v of vals) {
                    const n = parseFloat(v);
                    if (Number.isFinite(n) && n > 0) return n;
                }
                return 0;
            };
            const hotelsSum = sumHotelLineTotals(cquotation.hotels);
            const hotel = pickPositiveAmount(
                lc.hotel_cost,
                p?.hotel?.total,
                cquotation.hotel_cost,
                hotelsSum
            );
            const transport = parseFloat(lc.transportation_cost ?? cquotation.transportation_cost ?? 0) || 0;
            const otherAddons = parseFloat(lc.other_addons_cost ?? 0) || 0;
            const itineraries = cquotation.itineraries || cquotation.itenaries || [];
            const itineraryActivitiesSum = sumItineraryActivitiesAndTransfers(itineraries);
            const hasLandcascade = !!(p && p.landcascade && typeof p.landcascade === 'object'
                && Object.keys(p.landcascade).length > 0);
            let activities = 0;
            if (hasLandcascade) {
                activities = parseFloat(lc.activities_cost || 0) || 0;
            } else {
                activities = itineraryActivitiesSum;
                // Legacy fallback only when itineraries are absent and land rollup is not a hotel duplicate
                if (activities <= 0 && (!Array.isArray(itineraries) || itineraries.length === 0)) {
                    const landPkg = parseFloat(p?.landpackage?.total ?? cquotation.land_cost ?? 0) || 0;
                    if (landPkg > 0 && Math.abs(landPkg - hotel) >= 1) {
                        activities = landPkg;
                    }
                }
            }
            const cruise = parseFloat(lc.cruise_cost ?? p?.cruise?.total ?? cquotation.cruise_cost ?? 0) || 0;
            const visa = parseFloat(lc.visa_cost ?? p?.visa?.total ?? cquotation.visa_cost ?? 0) || 0;
            const insurance = parseFloat(lc.insurance_cost ?? p?.insurance?.total ?? cquotation.travel_insurance_cost ?? 0) || 0;
            const flight = parseFloat(p?.flight?.total ?? cquotation.flight_cost ?? 0) || 0;
            const helicopter = parseFloat(hc.helicopter_cost ?? cquotation.helicopter_cost ?? 0) || 0;
            const tcsincluded = !!(lc.tcsincluded ?? p?.tcsincluded ?? (
                this.enquiry.dest_team === 'International'
                && (this.enquiry.is_landpackage || cquotation.is_landpackage == 1)
            ));

            this.convertform.hotelprice = hotel;
            this.convertform.landprice = activities;
            this.convertform.cruiseprice = cruise;
            this.convertform.visaprice = visa;
            this.convertform.travelinsuranceprice = insurance;
            this.convertform.flightprice = flight;
            this.convertTransportationInput = transport;
            this.convertOtherAddonsInput = otherAddons;
            this.convertHelicopterInput = helicopter;
            this.convertTcsIncluded = tcsincluded;

            this.convertExtraMarkupAddons = (lc.markup_addons || [])
                .filter((line) => line && line.code !== 'transportation' && parseFloat(line.cost || 0) > 0)
                .map((line) => ({
                    code: line.code,
                    name: line.name,
                    cost: parseFloat(line.cost || 0) || 0,
                }));

            this.convertShow = {
                hotel: !!(this.enquiry.is_hotel || hotel > 0 || cquotation.hotel_includes == 1),
                flight: !!(this.enquiry.is_flight || flight > 0 || cquotation.flight_includes == 1),
                visa: !!(this.enquiry.is_visa || visa > 0),
                land: !!(this.enquiry.is_landpackage || activities > 0 || cquotation.is_landpackage == 1),
                cruise: !!(this.enquiry.is_cruise || cruise > 0),
                insurance: !!(this.enquiry.is_insurance || insurance > 0),
                transportation: transport > 0 || !!(lc.markup_addons || []).some((l) => l.code === 'transportation'),
                other_addons: otherAddons > 0 || this.convertExtraMarkupAddons.length > 0,
                helicopter: helicopter > 0 || !!(p?.separate_cascades || []).some((l) => parseFloat(l.cost || 0) > 0),
                land_cascade: false,
            };
            this.convertShow.land_cascade = this.convertShow.hotel
                || this.convertShow.land
                || this.convertShow.cruise
                || this.convertShow.visa
                || this.convertShow.insurance
                || this.convertShow.transportation
                || this.convertShow.other_addons;

            this.convertemodel = true;
            this.calculateconvertprofit();
        },
        buildConvertAddons() {
            const addons = [];
            const transport = parseFloat(this.convertTransportationInput || 0) || 0;
            const otherAddons = parseFloat(this.convertOtherAddonsInput || 0) || 0;
            const helicopter = parseFloat(this.convertHelicopterInput || 0) || 0;
            const types = this.convertAddonTypes || DEFAULT_ADDON_TYPES;

            if (transport > 0 || this.convertShow.transportation) {
                const t = types.find((x) => x.code === 'transportation') || { name: 'Transportation' };
                addons.push({ name: t.name, pricing: { total: transport } });
            }

            (this.convertExtraMarkupAddons || []).forEach((line) => {
                if (!line || !line.name) return;
                addons.push({
                    name: line.name,
                    pricing: { total: parseFloat(line.cost || 0) || 0 },
                });
            });

            if (otherAddons > 0 || this.convertShow.other_addons) {
                addons.push({ name: 'Other Addons', pricing: { total: otherAddons } });
            }

            if (helicopter > 0 || this.convertShow.helicopter) {
                const h = types.find((x) => x.code === 'helicopter') || { name: 'Helicopter' };
                addons.push({ name: h.name, pricing: { total: helicopter } });
            }

            return addons;
        },
        calculateconvertprofit() {
            const rates = this.convertRates || DEFAULT_PRICING_RATES;
            const addonTypes = this.convertAddonTypes || DEFAULT_ADDON_TYPES;
            const addons = this.buildConvertAddons();

            const hotelCost = parseFloat(this.convertform.hotelprice || 0) || 0;
            const cruiseCost = parseFloat(this.convertform.cruiseprice || 0) || 0;
            const visaCost = parseFloat(this.convertform.visaprice || 0) || 0;
            const insuranceCost = parseFloat(this.convertform.travelinsuranceprice || 0) || 0;
            const activitiesCost = parseFloat(this.convertform.landprice || 0) || 0;
            const flightCost = parseFloat(this.convertform.flightprice || 0) || 0;
            const tcsincluded = !!this.convertTcsIncluded;

            const landcascade = calculateLandCascade({
                hotelCost,
                cruiseCost,
                visaCost,
                insuranceCost,
                activitiesCost,
                addons,
                tcsincluded,
            }, rates, addonTypes);

            const separate_cascades = calculateSeparateCascades({ addons }, addonTypes);
            const heli = calculateHelicopterCascade({ addons }, rates, addonTypes);

            const flightServicePct = Number(rates.flight_service_charge ?? DEFAULT_PRICING_RATES.flight_service_charge);
            const flightGstPct = Number(rates.flight_gst ?? DEFAULT_PRICING_RATES.flight_gst);
            const flight_service = roundMoney((roundMoney(flightCost) / 100) * flightServicePct);
            const flight_gst = roundMoney((roundMoney(flight_service) / 100) * flightGstPct);
            const flight_subtotal = roundMoney(flightCost + flight_service);
            const flight_total = roundMoney(flightCost + flight_service + flight_gst);

            const taxesAbsorbed = Number(rates.taxes_absorbed) === 1;
            const charged = applyDiscountBeforeTax({
                landBeforeGst: landcascade.land_before_gst,
                tcsIncluded: tcsincluded,
                landGstPercent: rates.land_gst,
                tcsPercent: rates.tcs,
                flightFare: flightCost,
                flightService: flight_service,
                flightServiceAdult: flight_service,
                adults: 1,
                flightGstPercent: flightGstPct,
                separateLines: (separate_cascades || []).map((line) => ({
                    code: line.code,
                    name: line.name,
                    before_gst: line.before_gst,
                    gst_percent: line.gst_percent,
                })),
                discountType: this.convertform.discount_type,
                discountValue: this.convertform.discount_value,
                taxesAbsorbed,
            });

            this.convertLandCascade = landcascade;
            this.convertSeparateCascades = separate_cascades;
            this.convertCharged = charged;
            this.convertFlight = {
                service: flight_service,
                gst: charged.flight_gst,
                subtotal: flight_subtotal,
                total: roundMoney(flightCost + flight_service + charged.flight_gst),
            };

            this.convertform.quoteprice = charged.customer_total;
            this.convertform.tdsprice = charged.tcs;
            this.convertform.discount_amount = charged.discount_amount;
            this.convertform.pre_tax_discount = charged.pre_tax_discount;
            this.convertform.land_after_discount = charged.land_after_discount;
            this.convertform.land_gst_percent = Number(rates.land_gst) || 0;
            this.convertform.tcs_percent = Number(rates.tcs) || 0;
            this.convertform.tcs_included = tcsincluded ? 1 : 0;
            this.convertform.taxes_absorbed = taxesAbsorbed ? 1 : 0;
            if (charged.discount_error) {
                toastr.warning(charged.discount_error);
            }
            if (charged.discount_amount <= 0) {
                this.convertform.discount_reason = '';
            }

            this.convertform.land_gst = charged.land_gst;
            this.convertform.flight_gst = charged.flight_gst;
            this.convertform.land_profit = landcascade.land_profit;
            this.convertform.flight_profit = flight_service;
            this.convertform.land_quote_price = taxesAbsorbed ? charged.land_after_discount : charged.land_total;
            this.convertform.flight_quote_price = this.convertFlight.total;
            this.convertform.hotel_profit = landcascade.hotel_profit;
            this.convertform.transportation_cost = landcascade.transportation_cost;
            this.convertform.transportation_profit = landcascade.transportation_profit;
            this.convertform.backup_cost = landcascade.backup_cost;
            this.convertform.service_cost = landcascade.service_cost;
            this.convertform.land_before_gst = landcascade.land_before_gst;
            this.convertform.helicopter_cost = heli.helicopter_cost;
            this.convertform.helicopter_profit = heli.helicopter_profit;
            this.convertform.helicopter_gst = charged.helicopter_gst;
            this.convertform.helicopter_total = roundMoney(
                (parseFloat(heli.helicopter_cost) || 0)
                + (parseFloat(heli.helicopter_profit) || 0)
                + charged.helicopter_gst
            );
            this.convertform.gst = roundMoney(charged.land_gst + charged.flight_gst + charged.separate_gst).toFixed(2);
            this.convertform.profit = roundMoney(
                (parseFloat(landcascade.land_profit) || 0)
                + flight_service
                + (parseFloat(heli.helicopter_profit) || 0)
            ).toFixed(2);
        },
        submitConvertForm() {
            const formEl = this.$refs.convertFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    const charged = applyDiscountBeforeTax({
                        landBeforeGst: this.convertform.land_before_gst,
                        tcsIncluded: !!this.convertform.tcs_included,
                        landGstPercent: this.convertform.land_gst_percent,
                        tcsPercent: this.convertform.tcs_percent,
                        discountType: this.convertform.discount_type,
                        discountValue: this.convertform.discount_value,
                        taxesAbsorbed: Number(this.convertform.taxes_absorbed) === 1,
                    });
                    if (charged.discount_error) {
                        toastr.error(charged.discount_error);
                        return false;
                    }
                    this.submitconvert()
                } else {
                    return false
                }
            })
        },
        submitconvert() {
            let currentObj = this;
            currentObj.converting = true;
            axios.post('/enquiry/convert', this.convertform).then(function (response) {
                toastr.success('Enquiry Sucessfully Converted.');
                currentObj.converting = false;
                currentObj.$emit("saved");
                currentObj.convertemodel = false;

            })
                .catch(function (error) {
                    currentObj.converting = false;
                    const msg = error?.response?.data?.error;
                    if (msg) {
                        toastr.error(msg);
                    }
                });
        }

    }
}
</script>

<style scoped>
.convert-section-title {
    margin: 12px 0 8px;
    font-weight: 600;
    font-size: 14px;
}
.land-cascade-title {
    margin-bottom: 10px;
}
.land-cascade-table {
    width: 100%;
    border-collapse: collapse;
}
.land-cascade-table td {
    padding: 6px 10px;
    border-bottom: 1px solid #ebeef5;
    font-size: 13px;
}
.land-cascade-table td.amt {
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}
.land-cascade-table tr.sub td {
    color: #606266;
    font-weight: 600;
}
.land-cascade-table tr.grand-row td {
    font-weight: 700;
    font-size: 15px;
    background: #ecf5ff;
    border-bottom: none;
}
.land-cascade-summary p {
    margin: 2px 0;
}
</style>
